import { createSelector } from 'reselect';
import get from 'lodash/get';
import commonSelector, { selectedCustomerIdSelector } from '@store/common/selectors';
import comparisonSelector from '@store/comparison/selectors';
import { SCOPE } from '../types';
import { COMPARE_SHARING_SCOPE } from './types';

const selector = state => get(state, [SCOPE, COMPARE_SHARING_SCOPE]);

export default selector;

export const compareSharingSelector = createSelector(
  commonSelector,
  comparisonSelector,
  selectedCustomerIdSelector,
  (commonStore, comparisonStore, selectedCustomerId) => {
    const dashboard = 'comparison';
    const {
      interval: {
        from,
        to,
      },
    } = commonStore;
    const title = `Comparison ${from} ${to}`;
    const { filterIndices } = comparisonStore;

    return {
      title,
      dashboard,
      start: from,
      end: to,
      state: {
        comparison: {
          filterIndices,
        },
        common: { selectedCustomerId },
      },
    };
  },
);

export const compareSharingResponseSelector = createSelector(
  selector,
  (store) => {
    const { response } = store;
    if (!response) {
      return null;
    }
    const { state, id } = response;
    return {
      state: JSON.parse(state),
      id,
    };
  },
);
